// 节流
export function throttle(wait=500){
	return function (target, name, descriptor){
		var oldValue = descriptor.value;
		let previous = 0;
		descriptor.value = function() {
		    let now = Date.now();
	        let context = this;
	        let args = arguments;
	        let res;
	        if (now - previous > wait) {
	            res = oldValue.apply(context, args);
	            previous = now;
	        }
	        return res;
		};
		return descriptor;
	}
}

// 防抖
export function debounce(wait=500){
	return function (target, name, descriptor){
		var oldValue = descriptor.value;
		let timeout;
		descriptor.value = function() {
		    let context = this;
	        let args = arguments;

	        if (timeout) clearTimeout(timeout);

	        let callNow = !timeout;
	        timeout = setTimeout(() => {
	            timeout = null;
	        }, wait)

	        if (callNow) return oldValue.apply(context, args)
		};
		return descriptor;
	}
}


export function checkExpired(code){
	return function checkExpired (target, name, descriptor){
		var oldValue = descriptor.value;
		descriptor.value = function() {
			var model=arguments[0].state[code];
			if(model&&new Date().getTime()<=arguments[0].state.dateList[code]){
				return null;
			}
			return oldValue.apply(this, arguments);
		};
		return descriptor;
	}
}
